export function isNullish<T>(value: T | undefined | null): value is undefined | null {
  return value === undefined || value === null;
}

export const isNotNullish = <T>(value: T): value is NonNullable<T> => !isNullish(value);

export const isServer = (): boolean => typeof window === 'undefined';
